// extracted by mini-css-extract-plugin
export default {"checkbox_wrapper":"rjUpdationForm_checkbox_wrapper__1gG-j","FormTabs_root":"rjUpdationForm_FormTabs_root__+qda6"};